<template>
	<div>
		<h1>P P U</h1>
	</div>
</template>

<script>
	export default {
		
	}
</script>

<style lang="scss" scoped>

</style>